import { ComponentPropsWithRef } from 'react';

import { SingleButton } from './SingleButton';

import { SingleButtonSelectStyled } from './SingleButtonSelect.styles';

export interface SingleButtonSelectProps extends ComponentPropsWithRef<'div'> {
  useScroll?: boolean;
}

export function SingleButtonSelect({ children, useScroll, ...props }: SingleButtonSelectProps) {
  return (
    <SingleButtonSelectStyled role="tablist" aria-label="single button select" data-use-scroll={useScroll} {...props}>
      {children}
    </SingleButtonSelectStyled>
  );
}

SingleButtonSelect.Button = SingleButton;
